var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var FarmerProfilePageStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100vw;\n  background-color: ", ";\n"], ["\n  width: 100vw;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.ghostGray;
});
var templateObject_1;
//# sourceMappingURL=FarmerProfilePageStyled.js.map